/**
 * Given a list of active subscription tiers, check if a specific subscription tier is included/allowed.
 *
 * For example if a user has a `SubscriptionTier.TEAM`, this function also returns true when checking for `SubscriptionTier.PRO`.
 */

import SubscriptionTier from '@pkgs/shared/enums/SubscriptionTier';

const PRIVILEGE_TO_TIERS_MAP = {
	[SubscriptionTier.STARTER]: [
		SubscriptionTier.STARTER,
		SubscriptionTier.PRO,
		SubscriptionTier.SITE_MAKER,
		SubscriptionTier.TEAM,
		SubscriptionTier.ENTERPRISE,
	],
	[SubscriptionTier.PRO]: [
		SubscriptionTier.PRO,
		SubscriptionTier.SITE_MAKER,
		SubscriptionTier.TEAM,
		SubscriptionTier.ENTERPRISE,
	],
	[SubscriptionTier.SITE_MAKER]: [
		SubscriptionTier.SITE_MAKER,
		SubscriptionTier.TEAM,
		SubscriptionTier.ENTERPRISE,
	],
	[SubscriptionTier.TEAM]: [SubscriptionTier.TEAM, SubscriptionTier.ENTERPRISE],
	[SubscriptionTier.ENTERPRISE]: [SubscriptionTier.ENTERPRISE],
};

export default function subscriptionTiersHasSubscriptionTierPrivileges(
	activeSubscriptionTiers: ValueOf<typeof SubscriptionTier>[],
	subscriptionTier: ValueOf<typeof SubscriptionTier>,
): boolean {
	if (activeSubscriptionTiers && activeSubscriptionTiers.length > 0) {
		return PRIVILEGE_TO_TIERS_MAP[subscriptionTier].some((tier) =>
			activeSubscriptionTiers.includes(tier),
		);
	}

	return false;
}
